<template>
  <div class="footer">
    <div class="container">
      <div class="row">
        <div class="col-md">
          <router-link to="/">
            <img :src="require('../assets/images/footer_logo.svg')" />
          </router-link>
        </div>
        <div class="col-md">
          <ul class="nav flex-column">
            <li class="nav-item">
              <p class="nav-link active mb-0">Descarga la app</p>
            </li>
            <li class="nav-item">
              <a
                target="_blank"
                href="https://apps.apple.com/il/app/jabrutouch/id1488439011"
                class="nav-link float-left"
                ><i class="fab fa-apple"></i
              ></a>
              <a
                target="_blank"
                href="https://play.google.com/store/apps/details?id=co.il.jabrutouch"
                class="nav-link"
                ><i class="fab fa-android"></i
              ></a>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/estudia">Estudia</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/mishnayot">Mishná</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/estudia">Guemará</router-link>
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                href="#"
                @click.prevent="navigateToTodaysLesson()"
                >Daf Hayomi</a
              >
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="#"
                >Planes de estudio</router-link
              >
            </li>
            <li class="nav-item">
              <div id="google_translate_element"></div>
            </li>
          </ul>
        </div>
        <div class="col-md">
          <ul class="nav flex-column">
            <li class="nav-item">
              <router-link class="nav-link" to="/descubre"
                >Descubre Jabrutouch</router-link
              >
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/participa"
                >Participa de la próxima versión</router-link
              >
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/about">Conócenos</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/regala"
                >Regala Ketarim</router-link
              >
            </li>
            <li class="nav-item mt-5">
              <router-link
                class="nav-link font-weight-light"
                to="/politica-de-privacidad"
                >Política de privacidad</router-link
              >
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="terminos-y-condiciones"
                >Términos y condiciones</router-link
              >
            </li>
            <li class="nav-item">
              <router-link
                class="nav-link"
                :to="{ name: 'nosotros', hash: '#contacto' }"
                >Soporte y contacto</router-link
              >
            </li>
ta -->
          </ul>
        </div>
      </div>
      <div class="text-center copyright">© 2020 Jabrutouch</div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  mounted() {
    this.$nextTick(() => {
      this.googleTranslateInit();
    });
  },
  computed: {
    todaysLesson: function () {
      return this.$store.state.todaysLesson;
    },
  },
  methods: {
    googleTranslateInit: function () {
      let checkIfGoogleLoaded = setInterval(() => {
        if (google.translate.TranslateElement != null) {
          clearInterval(checkIfGoogleLoaded);

          this.googleTranslateElement("google_translate_element");
        }
      }, 100);
    },
    selectLang(lang) {
      var iframeWindow = window.frames[0];
      var element = iframeWindow.document.getElementsByClassName(
        ".goog-te-menu2-item span.text:contains(" + lang + ")"
      )[0];
      element.click();
    },
    googleTranslateElement: function (id) {
      new google.translate.TranslateElement(
        {
          pageLanguage: "es",
          layout: google.translate.TranslateElement.InlineLayout.SIMPLE,
          includedLanguages: "en,fr,he",
        },
        id
      );
    },
    navigateToTodaysLesson: function () {
      this.$router.push({
        name: "lesson",
        params: { id: this.todaysLesson.data.id.toString() },
      });
    },
  },
};
</script>
<style lang="scss">
.footer {
  background: #2d2ba9;
  padding: 40px 0 20px;
  color: #fff !important;
  .nav-link {
    color: #fff !important;
  }
}
.copyright {
  font-weight: 300;
  font-size: 14px;
  padding-top: 30px;
  border-top: 1px solid #3c3aab;
  margin-top: 30px;
}
#google_translate_element {
  * {
    font-family: Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif,
      "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol",
      "Noto Color Emoji";
  }
  padding: 13px;
  .goog-te-gadget-simple {
    background: transparent;
    border: 0;
    .goog-te-gadget-icon {
      display: none;
    }
  }
}
.goog-te-gadget-simple .goog-te-menu-value {
  color: #fff;
  ont-weight: 500;
  font-size: 1rem;
}
iframe.goog-te-menu-frame.skiptranslate {
  border-radius: 5px;
  box-shadow: -4px -3px 10px rgba(0, 0, 0, 0.3);
}
</style>